import _ from 'underscore'
import $filter from '../filter'
import $api from 'core/api'

var cache = {}

var templates = {
    numeric: {
        match: {
            '=': 'Is {value} {unit}',
            '!=': 'Is not {value} {unit}'
        },
        min: {
            '>=': 'At least {value} {unit}',
            '>': 'More than {value} {unit}'
        },
        max: {
            '<=': 'At most {value} {unit}',
            '<': 'Less than {value} {unit}'
        },
        range: {
            '=': 'Between {value} and {to} {unit}'
        },
        tolerance: {
            '=': 'Within ±{tolerance} of {value} {unit}'
        }
    },
    category: {
        match: {
            '=': 'Is {value}',
            '!=': 'Is not {value}'
        }
    },
    text: {
        contains: {
            '=': 'Contains {value}',
            '!=': 'Does not contain {value}'
        }
    },
    set: {
        match: {
            '=': 'Is {value}',
            '!=': 'Is not {value}'
        },
        min: {
            '>=': 'At least {value} {unit}',
            '>': 'More than {value} {unit}'
        },
        max: {
            '<=': 'At most {value} {unit}',
            '<': 'Less than {value} {unit}'
        },
        oneof: {
            '=': 'Is one of {value}',
            '!=': 'Is not one of {value}'
        },
        someof: {
            '=': 'Is {tolerance} of {value}',
            '!=': 'Is not {tolerance} of {value}',
            '>=': 'Is at least {tolerance} of {value}',
            '>': 'Is more than {tolerance} of {value}',
            '<=': 'Is at most {tolerance} of {value}',
            '<': 'Is less than {tolerance} of {value}'
        },
        allof: {
            '=': 'Is all of {value}',
            '!=': 'Is not all of {value}'
        }
    },
    date: {
        match: {
            '=': function(rule) {

                if (rule.setting.period === 'week') {

                    return 'In week of {value}'

                } else  if (rule.setting.period === 'day') {

                    return 'On {value}'

                } else {

                    return 'In {value}'

                }

            },
            '!=': function(rule) {

                if (rule.setting.period === 'week') {

                    return 'Not in week of {value}'

                } else  if (rule.setting.period === 'day') {

                    return 'Not on {value}'

                } else {

                    return 'Not in {value}'

                }
                
            }
        },
        min: {
            '>=': 'On or after {value}',
            '>': 'After {value}'
        },
        max: {
            '<=': 'On or before {value}',
            '<': 'Before {value}'
        },
        range: {
            '=': 'Between {value} and {to}'
        },
        rolling: {
            '=': 'Within the last {value} {unit}'
        }
    }
}

export default {

    cache: function(name, value) {

        if (value !== undefined) {

            cache[name] = value

        }

        return cache[name] || false

    },

    run: async function(value, $route) {

        var text = [await this.generate(value.rule, $route)]

        var links = await Promise.all(_.map(value.links, function(link) {
           return this.generate(link, $route, true)
        }.bind(this)))

        _.each(links, function(s) { text.push((s || '').toLowerCase()) })

        text = text.filter(function(str) {
            return str !== '';
        })

        return text.join(' and ')

    },

    generate: async function(rule, $route, isLinked) {

        if (!rule.setting) return ''

        isLinked = isLinked || false

        var typeKey = rule.type
        var type = $filter.type[typeKey]

        var template = (templates[type.type]) ? templates[type.type][rule.setting.logic][rule.logic.operand] : ''

        if(_.isFunction(template)) template = template(rule)

        var isCustomTemplate = false

        if (type.lang.summarise) {

            if(_.isObject(type.lang.summarise.template)) {

                if (type.type === 'toggle') {

                    template = type.lang.summarise.template[rule.logic.value]

                    isCustomTemplate = true

                } else {

                    if (type.lang.summarise.template[rule.setting.logic]) {

                        template = type.lang.summarise.template[rule.setting.logic][rule.logic.operand]

                        isCustomTemplate = true

                    }

                }

            } else if(_.isString(type.lang.summarise.template)) {

                template = type.lang.summarise.template

                isCustomTemplate = true

            }

        }

        if(!template) return ''

        var unit = (_.isFunction(type.lang.unit)) ? type.lang.unit(rule) : type.lang.unit || 0

        if (type.format.currency) {

            template = template.replace('{value}', '${value}')

        }

        if (_.isArray(rule.logic.value)) {

            var values = []

            if (type.set) {

                _.each(rule.logic.value, function(value) {

                    if (values.length) values.push(', ')

                    values.push(type.set[value])

                })

            } else {

                var unknownValues = _.difference(rule.logic.value, _.keys(cache))

                if (unknownValues.length) {

                    var params = JSON.parse(JSON.stringify($route.params))

                    params.values = unknownValues

                    var response = await $api.post(['users', 'filters', type.key.replace('.', '_')], params, {
                        cache: true,
                        nonblock: true
                    })

                    _.each(response.options, function(option) {

                        cache[option.value] = option.text

                    })
        
                }

                _.each(rule.logic.value, function(value) {

                    if (values.length) values.push(', ')

                    values.push((cache[value]) ? cache[value] : value)

                })

            }

            if (values.length === 3) values[1] = (type.type === 'oneof') ? ' or ' : ' and '
            if (values.length > 3) values[values.length - 2] = (type.type === 'oneof') ? ', or ' : ', and '

            template = template.replace('{value}', values.join(''))

        } else {

            if(type.format.percent) {

                template = template.replace('{value}', '{value}%')

            }

            template = template.replace('{value}', rule.logic.value)

        }

        if(unit) {

            template = template.replace('{unit}', (rule.logic.value === 1) ? unit : unit + 's')

        } else {

            template = template.replace(' {unit}', '')

        }

        if(type.format.percent) {

            template = template.replace('{to}', '{to}%')

        }

        if(rule.logic.tolerance) template = template.replace('{tolerance}', rule.logic.tolerance)
        if(rule.logic.to) template = template.replace('{to}', rule.logic.to)

        if (type.options) {

            template = template.replace('{option}', type.options[rule.logic.value].toLowerCase())

        }

        if (rule.setting.range && !isCustomTemplate) {

            template = '{range} ' + template  

        }

        if (rule.setting.count && !isCustomTemplate) {

            template = '{count} ' + template  

        }

        if (rule.setting.range) {

            template = template.toLowerCase().replace('is ', '')

            if(rule.setting.range === 'exact') {

                if(rule.setting.logic === 'range') {

                    template = template.replace('between ', ' ')
                    template = template.replace(' and ', ' to ')

                }

                template = template.replace('{range}', 'is exactly')

            } else if(rule.setting.range === 'low') {

                template = template.replace('{range}', 'low end is')

            } else if(rule.setting.range === 'high') {

                template = template.replace('{range}', 'high end is')

            } else if(rule.setting.range === 'within') {

                if(rule.setting.logic === 'range') {

                    template = template.replace('between ', ' ')
                    template = template.replace(' and ', ' to ')

                } else if(rule.setting.logic === 'tolerance') {

                    template = template.replace('within ', ' ')

                }

                template = template.replace('{range}', 'covers')

            }

        }

        if (type.lang.summarise && !isCustomTemplate) {

            if (type.lang.summarise.prefix && (!isLinked || !type.lang.summarise.prefixLinked)) template = type.lang.summarise.prefix + ' ' + template.toLowerCase()

            if (type.lang.summarise.prefixLinked && isLinked) template = type.lang.summarise.prefixLinked + ' ' + template.toLowerCase()
            
            if (type.lang.summarise.postfix) template = template + ' ' + type.lang.summarise.postfix

        }

        if (rule.setting.count) {

            template = template.replace('count {count}', '{count}')

            if (rule.setting.count === 'best') {

                template = template.replace('{count}', 'best count')

            } else if (rule.setting.count === 'recommended') {

                template = template.replace('{count}', 'best or recommended count')

            }

        }

        return String(template || '')

    }

}